import { Modal, Box, Typography } from "@mui/material";
import ButtonComponent from "components/button/ButtonComponent";
import Notify from "config/notify";
import { useEffect, useState } from "react";
import { NotificationState } from "type";

/**
 * ConfirmModal component to display a confirmation modal.
 */
export default function ConfirmModal() {
  const [confirm, setConfirm] = useState<NotificationState>({
    show: false,
    title: "",
    message: "",
    titleColor: "",
    messageColor: "",
  });

  useEffect(() => {
    Notify.setConfirm = setConfirm;
  }, []);

  const handleClose = () => {
    setConfirm({ show: false, title: "", message: "" });
    Notify.onClose?.();
  };

  const handleResult = (result: boolean) => {
    if (confirm.onResult) confirm.onResult(result);
    handleClose();
  };

  return (
    <Modal
      open={confirm.show}
      onClose={handleClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          px: 6,
          py: 4,
          backgroundColor: "var(--white)",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "400px",
        }}
      >
        {confirm.title ? (
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: "bold",
              color: confirm.titleColor || "var(--gray-700)",
            }}
          >
            {confirm.title}
          </Typography>
        ) : null}
        {confirm.message ? (
          <Typography sx={{ color: confirm.messageColor || "var(--gray-700)", mt: 1 }}>
            {confirm.message}
          </Typography>
        ) : null}
        <div style={{ textAlign: "right", width: "100%" }}>
          <ButtonComponent
            label="いいえ"
            onClick={() => handleResult(false)}
            sx={{ mt: 2, mr: 1, width: "auto", px: 2, marginLeft: "auto" }}
          />
          <ButtonComponent
            label="はい"
            onClick={() => handleResult(true)}
            sx={{ mt: 2, width: "auto", px: 2, mx: 0 }}
          />
        </div>
      </Box>
    </Modal>
  );
}
